<script>
  /* Copyright (c) 2020 Jacques Desodt */
  import Button from './Button.svelte'
  import { createEventDispatcher } from 'svelte'
  const dispatch = createEventDispatcher()

  export let args = null
  export let date = null
</script>

<div class="_tp-wrapper {args.buttonBarClassName}">
  <div class="_tp-button _tp-now">
    <Button
      {args}
      label={args.buttonNow}
      on:click={() => {
        date = new Date()
        dispatch('change')
      }}
    />
  </div>
  <div class="_tp-button _tp-ok">
    <Button {args} label={args.buttonOk} on:click={() => dispatch('ok')} />
  </div>
  <div class="_tp-button _tp-cancel">
    <Button {args} label={args.buttonCancel} on:click={() => dispatch('cancel')} />
  </div>
</div>

<style>
  ._tp-button {
    bottom: 0.5rem;
    position: absolute;
  }
  ._tp-cancel {
    right: 0.5rem;
  }
  ._tp-now {
    left: 0.5rem;
  }

  ._tp-wrapper {
    align-items: center;
    background-color: #fff;
    display: flex;
    flex-direction: row;
    font-size: 20px;
    height: 2.5rem;
    justify-content: center;
    position: relative;
    width: 100%;
  }
</style>
